import React, { useState } from "react";
import "./Header.scss";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { FiUser, FiLogOut, FiSettings } from "react-icons/fi";

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { admin, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const getHeading = () => {
    const routes = {
      "/dashboard": "Dashboard",
      "/users-list": "Users",
      "/app-version": "App Versions",
      "/services": "Services",
      "/service": "Service Details",
      "/user-details": "User Details",
      "/admin/orders/order-details": "Order Details",
      "/admin/users": "Users",
      "/admin/user-details": "User Details",
      "/admin/testimonials/add-testimonials": "Add Testimonials",
      "/admin/settings": "Settings",
      "/admin/pin-codes": "Pin Codes",
      "/admin/pin-codes/add-pin-code": "Add Pin Code",
      "/home-assist": "Home Assistance",
      "/roadside-assist": "Roadside Assistance",
      "/driver-assist": "Driver Assistance",
      "/legal-assist": "Legal Assistance",
      "/fines": "Fines Management",
      "/license": "License Renewals",
      "/roadside/completed-services": "Completed Services",
      "/roadside/inprogress-services": "In Progress Services",
      "/roadside/canceled-services": "Canceled Services",
    };

    return routes[location.pathname] || "Dashboard";
  };

  const getBreadcrumb = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);
    
    if (pathnames.length === 0 || pathnames[0] === "dashboard") {
      return null;
    }

    return (
      <div className="breadcrumb">
        <span onClick={() => navigate("/dashboard")} className="breadcrumb-item">
          Home
        </span>
        {pathnames.map((name, index) => {
          const isLast = index === pathnames.length - 1;
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const displayName = name
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          return (
            <React.Fragment key={routeTo}>
              <span className="breadcrumb-separator">/</span>
              {isLast ? (
                <span className="breadcrumb-item active">{displayName}</span>
              ) : (
                <span
                  onClick={() => navigate(routeTo)}
                  className="breadcrumb-item"
                >
                  {displayName}
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const handleLogout = () => {
    if (logout) {
      logout();
    }
    navigate("/login");
  };

  const getInitials = (name) => {
    if (!name) return "AD";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <div className="header-main">
      <div className="left-header">
        <h4 className="page-title">{getHeading()}</h4>
        {getBreadcrumb()}
      </div>

      <div className="right-header">
        {/* User Profile */}
        <div className="user-profile">
          <div
            className="profile-display"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="avatar">
              <span>{getInitials(admin?.name || admin?.email)}</span>
            </div>
            <div className="user-info">
              <span className="user-name">
                {admin?.name || admin?.email || "Admin"}
              </span>
              <span className="user-role">{admin?.role || "Administrator"}</span>
            </div>
          </div>

          {/* Dropdown Menu */}
          {showDropdown && (
            <>
              <div
                className="dropdown-overlay"
                onClick={() => setShowDropdown(false)}
              />
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <div className="dropdown-avatar">
                    <span>{getInitials(admin?.name || admin?.email)}</span>
                  </div>
                  <div className="dropdown-user-info">
                    <span className="dropdown-name">
                      {admin?.name || admin?.email || "Admin"}
                    </span>
                    <span className="dropdown-email">{admin?.email}</span>
                  </div>
                </div>

                <div className="dropdown-divider"></div>

                <div className="dropdown-items">
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      navigate("/admin/settings");
                      setShowDropdown(false);
                    }}
                  >
                    <FiSettings />
                    <span>Settings</span>
                  </div>

                  <div
                    className="dropdown-item"
                    onClick={() => {
                      navigate("/profile");
                      setShowDropdown(false);
                    }}
                  >
                    <FiUser />
                    <span>Profile</span>
                  </div>

                  <div className="dropdown-divider"></div>

                  <div
                    className="dropdown-item logout"
                    onClick={() => {
                      handleLogout();
                      setShowDropdown(false);
                    }}
                  >
                    <FiLogOut />
                    <span>Logout</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}